module.exports = __webpack_public_path__ + "img/icons.940292c3.svg";